import React from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';

interface PdfViewerProps {
    src: string;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ src }) => {
    const toolbarPluginInstance = toolbarPlugin();

    return (
        <div
            className="relative max-w-[1000px] max-h-[90vh] bg-neutral-400 dark:bg-neutral-800 rounded-xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
            style={{
                width: '90vw',
                height: '90vh'
            }}
        >
            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                <Viewer
                    fileUrl={src}
                    plugins={[toolbarPluginInstance]}
                />
            </Worker>
        </div>
    );
};

export default PdfViewer;